'use strict';

var dagNodeUtil = require('./util');

var cloneLinks = dagNodeUtil.cloneLinks;
var cloneData = dagNodeUtil.cloneData;

var create = require('./create');

function clone(dagNode, callback) {
  var data = cloneData(dagNode);
  var links = cloneLinks(dagNode);
  create(data, links, callback);
}

module.exports = clone;